<template>
    <div class="deck"
    >
        <card slug="verso" v-for="i in cardsNbr" :key="'id_' + i"
            ref="cards"
            :flipped="true"
            :style="{bottom: (i*gap) + 'px', left: (i*gap) + 'px'}"
            @click="onCardClick(i, $event)"
        />
    </div>
</template>

<script>
    import Card from './Card'
    import style from '@/style/settings.scss'

    export default {
        components: {Card},

        props: {
            cardsNbr: {type: Number},
            maxPulledCard: {type: Number}
        },

        data () {return {
            gap: 2,
            cardWidth: parseFloat(style.cardWidth),
            cardHeight: parseFloat(style.cardHeight),
            pulledCounter: 0,
        }},

        created () {
            window.addEventListener('resize', this.onResize);
        },

        mounted () {
            this.onResize();
        },

        methods: {

            onCardClick (index, event) {
                if (index == this.cardsNbr) {
                    this.$emit('topCardClick', event);
                    this.pulledCounter += 1;
                }
            },

            getTopCard () {
                return this.$refs.cards[this.$refs.cards.length-1];
            },

            getTopCardPosition () {
                let topCard = this.getTopCard();

                let toY = this.$el.offsetTop + topCard.$el.offsetTop;
                let toX = topCard.$el.getBoundingClientRect().left;

                return {
                    left: toX,
                    top:  toY
                };
            },

            onResize () {
                if (window.innerWidth < parseInt(style.cardXsBreakpoint)) {
                    this.gap = parseInt(style.deckXsGap);
                }
                else if (window.innerWidth < parseInt(style.cardSBreakpoint)) {
                    this.gap = parseInt(style.deckSGap);
                }
                else this.gap = parseInt(style.deckGap);
            },

            reset () {
                this.pulledCounter = 0;
            },

        }
    }
</script>